/** Date ranges for the Visitors pages. Dates are ISO (YYYY-MM-DD) calendar
 *  days in America/New_York, matching the API (plan Phase 2). */
export type Preset = 'today' | 'yesterday' | '7d' | '30d' | '90d' | '12m' | 'custom'
export interface DateRange { from: string; to: string; preset: Preset }

const ISO = /^\d{4}-\d{2}-\d{2}$/
const DAYS: Record<Exclude<Preset, 'custom' | '12m' | 'yesterday'>, number> = { today: 1, '7d': 7, '30d': 30, '90d': 90 }

function addDays(iso: string, n: number): string {
  const d = new Date(`${iso}T12:00:00Z`)
  d.setUTCDate(d.getUTCDate() + n)
  return d.toISOString().slice(0, 10)
}

export function todayEastern(now: Date = new Date()): string {
  return new Intl.DateTimeFormat('en-CA', { timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit' }).format(now)
}

export function presetRange(preset: Exclude<Preset, 'custom'>, today: string): DateRange {
  if (preset === 'yesterday') {
    const y = addDays(today, -1)
    return { from: y, to: y, preset }
  }
  if (preset === '12m') {
    const d = new Date(`${today}T12:00:00Z`)
    d.setUTCFullYear(d.getUTCFullYear() - 1)
    return { from: addDays(d.toISOString().slice(0, 10), 1), to: today, preset }
  }
  return { from: addDays(today, 1 - DAYS[preset]), to: today, preset }
}

export function rangeFromSearch(sp: URLSearchParams, today: string): DateRange {
  const p = sp.get('range') as Preset | null
  if (p === 'custom') {
    const from = sp.get('from') ?? '', to = sp.get('to') ?? ''
    if (ISO.test(from) && ISO.test(to) && from <= to) return { from, to, preset: 'custom' }
    return presetRange('yesterday', today)
  }
  if (p && Object.hasOwn(DAYS, p)) return presetRange(p as Exclude<Preset, 'custom' | '12m' | 'yesterday'>, today)
  if (p === '12m' || p === 'yesterday') return presetRange(p, today)
  return presetRange('yesterday', today)
}

export function rangeToSearch(r: DateRange): Record<string, string> {
  return r.preset === 'custom' ? { range: 'custom', from: r.from, to: r.to } : { range: r.preset }
}

export function rangeQuery(pub: string, r: DateRange): string {
  return `publication=${encodeURIComponent(pub)}&from=${r.from}&to=${r.to}`
}
